/**
 * The AI agent queues: "Handling" is conversations sitting in `pending`, the
 * status agent-bot/Captain-handled conversations occupy; "Resolved by AI" is
 * resolved conversations whose resolution is attributed to the AI agent
 * (reporting events, filtered server-side). Gated behind the Captain feature
 * flag like the other flag-gated sidebar entries.
 *
 * "Handling" carries its queue size as the badge (delivered on the unread
 * counts payload). "Resolved by AI" is deliberately unbadged: its only honest
 * total grows forever, which makes a badge noise rather than signal.
 */
export default ({
  t,
  accountScopedRoute,
  hasCaptainEnabled,
  aiHandlingCount,
}) => {
  if (!hasCaptainEnabled) return null;

  return {
    name: 'AI Agent',
    label: t('SIDEBAR.AI_AGENT'),
    icon: 'i-ph-robot',
    children: [
      {
        name: 'Handling',
        label: t('SIDEBAR.AI_HANDLING'),
        icon: 'i-ph-sparkle',
        activeOn: ['conversation_through_ai_handling'],
        to: accountScopedRoute('conversation_ai_handling'),
        badgeCount: aiHandlingCount,
        // The queue size, not an unread tally - say so.
        badgeCountLabelKey: 'SIDEBAR.QUEUE_COUNT',
      },
      {
        name: 'Resolved by AI',
        label: t('SIDEBAR.AI_RESOLVED'),
        icon: 'i-ph-check-circle',
        activeOn: ['conversation_through_resolved_by_ai'],
        to: accountScopedRoute('conversation_resolved_by_ai'),
      },
    ],
  };
};
